"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _query = require("@reduxjs/toolkit/query");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _providers = require("../../../../providers");

var _hooks = require("../../../../../CampaignSettings/hooks");

var _messaging = require("../../../Messaging/constants/messaging.constants");

var _TextWithPlaceholders = _interopRequireDefault(require("../../../../../Shared/Messaging/Placeholders/components/TextWithPlaceholders/TextWithPlaceholders"));

var _useGetTeamMembersByTeamId = require("../../../../../Shared/Teams/hooks/useGetTeamMembersByTeamId");

var styles = {
  text: {
    color: 'text.primary',
    fontSize: '16px',
    lineHeight: '18px'
  },
  bold: {
    fontWeight: 700
  },
  avatar: {
    width: 60,
    height: 60,
    mr: 2
  },
  actions: {
    color: 'grey.main',
    fontSize: '14px',
    lineHeight: '18px',
    ml: 1,
    mt: 1
  },
  link: {
    mx: 0.5,
    fontSize: 14,
    fontWeight: 'normal',
    color: 'link.main'
  },
  messageBody: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-word'
  },
  protip: {
    lineHeight: '16px'
  },
  videoTip: {
    fontSize: 14,
    fontWeight: 'bold',
    color: 'green.fruitSalad',
    mt: 1
  }
};
var Span = (0, _material.styled)('span')({});

var MessagePreview = function MessagePreview() {
  var _campaign$team, _campaign$team2, _batch$messaging, _batch$video, _batch$messaging$mess, _batch$messaging2, _batch$messaging$mess2, _batch$messaging3;

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      batchId = _useGiftingFlowContex.batchId;

  var _useGetProspectingBat = (0, _services.useGetProspectingBatchByIdQuery)(batchId ? {
    batchId
  } : _query.skipToken),
      batch = _useGetProspectingBat.data;

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)((batch === null || batch === void 0 ? void 0 : batch.campaignId) || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var _useTeamMembers = (0, _hooks.useTeamMembers)(campaign === null || campaign === void 0 ? void 0 : (_campaign$team = campaign.team) === null || _campaign$team === void 0 ? void 0 : _campaign$team.id),
      useGetById = _useTeamMembers.useGetById;

  var _useGetTeamMembersByT = (0, _useGetTeamMembersByTeamId.useGetTeamMembersByTeamId)(campaign === null || campaign === void 0 ? void 0 : (_campaign$team2 = campaign.team) === null || _campaign$team2 === void 0 ? void 0 : _campaign$team2.id),
      useGetAll = _useGetTeamMembersByT.useGetAll;

  var teamMembers = useGetAll();
  var singleSendAs = useGetById(batch === null || batch === void 0 ? void 0 : batch.messaging.sendAsId);
  var sendAsPersons = batch === null || batch === void 0 ? void 0 : (_batch$messaging = batch.messaging) === null || _batch$messaging === void 0 ? void 0 : _batch$messaging.sendAsPersons;
  var sendAs = sendAsPersons !== null && sendAsPersons !== void 0 && sendAsPersons.length ? teamMembers.find(function (member) {
    return sendAsPersons && member.email === sendAsPersons[0].sendAsEmail;
  }) : singleSendAs;
  var meetingOwner = useGetById(batch === null || batch === void 0 ? void 0 : batch.meetingHosts.ownerId);
  var meetingAttendee = useGetById(batch === null || batch === void 0 ? void 0 : batch.meetingHosts.attendeeIds[0]);
  var hasRecipientActions = (0, _react.useMemo)(function () {
    return Object.values((batch === null || batch === void 0 ? void 0 : batch.recipientActions) || {}).some(Boolean);
  }, [batch]);
  var isMeetingRequired = batch === null || batch === void 0 ? void 0 : batch.recipientActions.captureDate;
  var hasVideo = !!(batch !== null && batch !== void 0 && (_batch$video = batch.video) !== null && _batch$video !== void 0 && _batch$video.type);
  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.text
  }, /*#__PURE__*/_react.default.createElement(Span, {
    sx: styles.bold
  }, "Subject:"), " ", /*#__PURE__*/_react.default.createElement(_TextWithPlaceholders.default, {
    text: (_batch$messaging$mess = batch === null || batch === void 0 ? void 0 : (_batch$messaging2 = batch.messaging) === null || _batch$messaging2 === void 0 ? void 0 : _batch$messaging2.messageSubject) !== null && _batch$messaging$mess !== void 0 ? _batch$messaging$mess : ''
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 0.5,
    sx: styles.text
  }, /*#__PURE__*/_react.default.createElement(Span, {
    sx: styles.bold
  }, "Message: ", /*#__PURE__*/_react.default.createElement("br", null)), ' ', /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.messageBody
  }, /*#__PURE__*/_react.default.createElement(_TextWithPlaceholders.default, {
    text: (_batch$messaging$mess2 = batch === null || batch === void 0 ? void 0 : (_batch$messaging3 = batch.messaging) === null || _batch$messaging3 === void 0 ? void 0 : _batch$messaging3.messageBody) !== null && _batch$messaging$mess2 !== void 0 ? _batch$messaging$mess2 : ''
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 1,
    sx: styles.text
  }, /*#__PURE__*/_react.default.createElement(Span, {
    sx: styles.bold
  }, "Signature:", /*#__PURE__*/_react.default.createElement("br", null)), ' ', /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2,
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    sx: styles.avatar,
    src: sendAs === null || sendAs === void 0 ? void 0 : sendAs.imageUrl
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.text
  }, sendAs === null || sendAs === void 0 ? void 0 : sendAs.firstName, " ", sendAs === null || sendAs === void 0 ? void 0 : sendAs.lastName, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    style: {
      display: 'inline',
      paddingLeft: 5
    },
    color: "#9b9b9b"
  }, sendAsPersons !== null && sendAsPersons !== void 0 && sendAsPersons.length ? "+".concat(sendAsPersons.length - 1, " senders") : '')), /*#__PURE__*/_react.default.createElement(_material.Link, {
    href: "mailto:".concat(sendAs === null || sendAs === void 0 ? void 0 : sendAs.email)
  }, sendAs === null || sendAs === void 0 ? void 0 : sendAs.email))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(Span, {
    sx: styles.bold
  }, "Preview:"), sendAsPersons && (sendAsPersons === null || sendAsPersons === void 0 ? void 0 : sendAsPersons.length) > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
    href: "/batch-email-preview/".concat(batchId),
    target: "_blank",
    sx: styles.link
  }, "Email"), batch !== null && batch !== void 0 && batch.previewLink ? '| ' : ''), (batch === null || batch === void 0 ? void 0 : batch.previewLink) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Link, {
    sx: styles.link,
    component: "a",
    href: batch === null || batch === void 0 ? void 0 : batch.previewLink,
    target: "_blank",
    rel: "noreferrer"
  }, "Landing page"), /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    sx: styles.protip,
    placement: "top",
    title: "This preview reflects the messaging to one of your contacts, but rest assured that these dynamic values will be applied for each of the messages to this gift's contacts."
  }, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: "exclamation-circle",
    color: "text",
    fontSize: 1
  }))))), hasVideo && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.videoTip
  }, "Note: Landing page includes video")), hasRecipientActions && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3,
    sx: styles.text
  }, /*#__PURE__*/_react.default.createElement(Span, {
    sx: styles.bold
  }, "Required actions to accept gift:", /*#__PURE__*/_react.default.createElement("br", null)), ' ', /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.actions
  }, Object.entries((batch === null || batch === void 0 ? void 0 : batch.recipientActions) || {}).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        action = _ref2[0],
        value = _ref2[1];

    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: action
    }, value === true && /*#__PURE__*/_react.default.createElement(_material.Box, null, _messaging.recipientActionLabels[action]));
  }))), isMeetingRequired && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3,
    sx: styles.text
  }, /*#__PURE__*/_react.default.createElement(Span, {
    sx: styles.bold
  }, "Meeting hosts:", /*#__PURE__*/_react.default.createElement("br", null)), ' ', /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.actions
  }, /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(Span, {
    sx: styles.bold
  }, "Meeting owner:"), ' ', (batch === null || batch === void 0 ? void 0 : batch.meetingHosts.ownerId) === 0 ? 'Sender' : "".concat(meetingOwner === null || meetingOwner === void 0 ? void 0 : meetingOwner.firstName, " ").concat(meetingOwner === null || meetingOwner === void 0 ? void 0 : meetingOwner.lastName)), meetingAttendee && /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(Span, {
    sx: styles.bold
  }, "Meeting attendee:"), " ", meetingAttendee === null || meetingAttendee === void 0 ? void 0 : meetingAttendee.firstName, " ", meetingAttendee === null || meetingAttendee === void 0 ? void 0 : meetingAttendee.lastName))));
};

var _default = MessagePreview;
exports.default = _default;